var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageRolesV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5003 10.921C13.5003 9.90702 13.0975 8.93452 12.3804 8.2175C11.6634 7.50048 10.6909 7.09766 9.6769 7.09766C8.66288 7.09766 7.69038 7.50048 6.97336 8.2175C6.25634 8.93452 5.85352 9.90702 5.85352 10.921",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67685 7.09785C11.0846 7.09785 12.2258 5.95666 12.2258 4.54892C12.2258 3.14119 11.0846 2 9.67685 2C8.26912 2 7.12793 3.14119 7.12793 4.54892C7.12793 5.95666 8.26912 7.09785 9.67685 7.09785Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87513 8.69566C5.28464 8.10517 4.48376 7.77344 3.64868 7.77344C2.8136 7.77344 2.01272 8.10517 1.42223 8.69566C0.831735 9.28616 0.5 10.087 0.5 10.9221",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64892 7.77246C4.80823 7.77246 5.74804 6.83265 5.74804 5.67334C5.74804 4.51403 4.80823 3.57422 3.64892 3.57422C2.48961 3.57422 1.5498 4.51403 1.5498 5.67334C1.5498 6.83265 2.48961 7.77246 3.64892 7.77246Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageRolesV2);
export default __webpack_public_path__ + "static/media/manageRolesV2.300a1031cb90160321c8612085b2c7e1.svg";
export { ForwardRef as ReactComponent };